<template>
  <div class="tech-roadmap-container">
    <div class="top-bg">
      <div class="title">
        <div>DO Technology</div>
        <div>Roadmap</div>
      </div>
      <div class="sub-title">What we did about the technical route?</div>
      <div class="content-text">We're proud of what we've accomplished with our community so far — and look forward to tackling challenges and building more with a whole new generation of participants.</div>
    </div>

    <div class="date-container">
      <div class="date-component" v-for="item of dateList" :key="item.id">
        <div class="date-quarter"><p>{{item.quarter}}</p></div>
        <div class="date-month">{{item.month}}</div>
        <div class="blue-divide"></div>
        <div class="date-desc">{{item.desc}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      dateList:[
        {
          id:1,
          quarter:"Q1",
          month:"2024-Q1",
          desc:"EVM launched, supporting ERC721/ERC20 protocols and deployment;\n Smart Contracts - Technical documentation upgraded and open-sourced;\nArk Wallet upgraded."
        },
        {
          id:2,
          quarter:"Q2",
          month:"2024-Q2",
          desc:"Support for cross-chain components;\n Open developer toolset;\n Launch of the Ecosystem Grant Incentive Program: DEFI/NFT/BTCLayer2/Web plugin wallet/Fairlaunch platform/DEX."
        },
        {
          id:3,
          quarter:"Q3",
          month:"2024-Q3",
          desc:"Host the inaugural Hackson;\n Support the expansion of the Game ecosystem;\n Facilitate full-chain interoperability;\n Promote a globally developer-driven autonomous ecosystem."
        },
        // {
        //   id:4,
        //   quarter:"Q1",
        //   month:"Mar 2022",
        //   desc:"Combine related modules of the DO Network."
        // },
        // {
        //   id:5,
        //   quarter:"Q2",
        //   month:"Apr 2022",
        //   desc:"Start the capital operation of the DO network."
        // },
        // {
        //   id:6,
        //   quarter:"Q2",
        //   month:"May 2022",
        //   desc:"Start the DO Network test network."
        // },
        // {
        //   id:7,
        //   quarter:"Q2",
        //   month:"June 2022",
        //   desc:"Enter the Test net Ark competition."
        // },
        // {
        //   id:8,
        //   quarter:"Q3",
        //   month:"Aug 2022",
        //   desc:"Launch the main network officially."
        // },
        // {
        //   id:9,
        //   quarter:"Q3",
        //   month:"Sep 2022",
        //   desc:"Launch the DAO Ecological Development Fund."
        // },
        // {
        //   id:10,
        //   quarter:"Q4",
        //   month:"Oct 2022",
        //   desc:"Launch the native autonomy voting for the DO network."
        // },
        // {
        //   id:11,
        //   quarter:"Q4",
        //   month:"Dec 2022",
        //   desc:"Start the autonomous development of open decentralization of the DAO protocol."
        // }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
  .tech-roadmap-container{
    .top-bg{
      padding: 230px 51px 0;
      height: 761px;
      text-align: center;
      background-image: url("../../../assets/m/techroadmap.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title{
        height:165px;
        font-size: 64px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 83px;
        -webkit-background-clip: text;
      }
      .sub-title{
        margin-top:20px;
        font-size: 30px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #000000;
        line-height: 35px;
        -webkit-background-clip: text;
      }
      .content-text{
        margin-top:20px;
        padding: 0 20px;
        height: 171px;
        font-size: 26px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #61666B;
        line-height: 43px;
        -webkit-background-clip: text;
      }
    }
    .date-container{
      margin-top:-60px;
      &:nth-last-child(1){
        margin-bottom: 100px;
      }
      .date-component{
        height: 623px;
        margin: 0 47px 50px;
        padding: 0 53px;
        border: 2px solid #FFFFFF;
        border-radius: 30px;
        box-shadow: 0px 22px 51px 1px rgba(46,87,192,0.05);
        background:rgba(251, 251, 251, 0.3);
        .date-quarter{
          padding-top:53px;
          p{
            width: 89px;
            height: 90px;
            line-height: 90px;
            font-size: 60px;
            font-family: Poppins-ExtraBold, Poppins;
            font-weight: 800;
            color: rgba(52, 51, 61, 0.08);
            -webkit-background-clip: text;
          }
        }
        .date-month{
          margin-top:14px;
          height: 90px;
          line-height: 90px;
          font-size: 60px;
          font-family: Poppins-ExtraBold, Poppins;
          font-weight: 800;
          color: #34333D;
          -webkit-background-clip: text;
        }
        .blue-divide{
          margin-top:50px;
          width: 60px;
          height: 6px;
          background: #4573E7;
        }
        .date-desc{
          margin-top:50px;
          height: 79px;
          font-size: 26px;
          font-family: Poppins-Regular, Poppins;
          font-weight: 400;
          color: #61666B;
          line-height: 39px;
          white-space: pre-line;
          -webkit-background-clip: text;
        }
      }
    }
  }
</style>